import { MessageCircle } from "lucide-react";
import { useSite } from "@/lib/site";

export const WhatsAppFloat = () => {
  const { content } = useSite();
  const number = (content.settings?.whatsapp_number || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${number}?text=${encodeURIComponent("Hi Yogyata, I'd like to know more about your consultations.")}`}
      onClick={() => window.__tblTrack?.("whatsapp_click")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 left-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-deep transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7 fill-white" />
    </a>
  );
};
